import React from "react";
import { Dropdown } from "react-bootstrap";

const PersonTable = ({ people, onDelete, onEdit, onAccept }) => (
  <div className="table-responsive neumorphic p-3 rounded">
    <table className="table table-bordered table-hover">
      <thead>
        <tr>
          <th>Prenume</th><th>Nume</th><th>CNP</th><th>Țara</th><th>Județ</th>
          <th>Oraș</th><th>Email</th><th>Telefon</th>
          <th>Membru</th><th>Voluntar</th><th>Membru și Voluntar</th><th>Timestamp</th><th>Acțiuni</th>
        </tr>
      </thead>
      <tbody>
        {people.map((p, index) => (
          <tr key={index}>
            <td>{p.prenume}</td><td>{p.nume}</td><td>{p.cnp}</td><td>{p.tara}</td>
            <td>{p.judet}</td><td>{p.oras}</td><td>{p.email}</td><td>{p.telefon}</td>
            <td>{p.membru ? "Da" : "Nu"}</td>
            <td>{p.voluntar ? "Da" : "Nu"}</td>
            <td>{p.membruVoluntar ? "Da" : "Nu"}</td>
            <td>{p.timestamp}</td>
            <td>
              <Dropdown
                onSelect={(action) => {
                  if (action === "edit") onEdit(p);
                  else if (action === "delete") onDelete(p.id);
                  else if (action === "accept") onAccept(p);
                }}
              >
                <Dropdown.Toggle variant="secondary" size="sm">
                  Acțiuni
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="edit">Editează</Dropdown.Item>
                  <Dropdown.Item eventKey="accept">Acceptă cerere</Dropdown.Item>
                  <Dropdown.Item eventKey="delete" className="text-danger">
                    Șterge
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default PersonTable;
